<template>
  <div class="breadcrumb">
    <nav class="breadcrumb__nav" v-if="hasBreadcrumb">
      <router-link
        :to="{name: 'company', params: {company: company.path}}"
        v-slot="{ href, route, navigate, isActive }"
      >
        <a
          :href="href"
          class="breadcrumb__nav__item"
          :class="{'-active': isActive}"
          @click="navigate"
        >{{company.name}}</a>
      </router-link>
      <span class="breadcrumb__nav__item" v-if="form">-</span>
      <span class="breadcrumb__nav__item" v-if="form">{{form}}</span>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: this.$store.getters.getActiveCompany,
      form: this.$route.params.form,
      list: [
        "companydetail",
        "companyformlist",
        "companynewform",
        "formdetail",
        "formfields",
        "formsmtp",
        "formperiod"
      ]
    };
  },
  watch: {
    $route: function() {
      this.company = this.$store.getters.getActiveCompany;
      this.form = this.$route.params.form;
    }
  },
  computed: {
    hasBreadcrumb() {
      return this.list.some(item => item == this.$route.name);
    }
  },
  methods: {}
};
</script>